import React, { useState, useEffect } from "react";
import { Icon, Image, Menu } from "semantic-ui-react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import cx from "classnames";

import AuthService from "services/auth.service";
import { fetchUserProfile } from "actions/users";
import styles from "./navbar.module.scss";
import { LOGOUT_COGNITO_USER } from "constants/actionTypes";
import PF_Logo from "../../../images/pf_logo.png";
import CS_Logo from "../../../images/cslogo.svg"
import { fetchAccounts } from "actions/accounts";

const initFilters = {
  query: null,
  subscriptions: [],
  sort: "name",
  order: "ASC",
  searchType: "NAME",
  product: "paperflite"
};

export default function Navbar() {
  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();

  const { pathname } = location;

  const me = useSelector((state) => state.users.me);

  const [activeItem, setActiveItem] = useState("accounts");
  const [product, setProduct] = useState("paperflite");

  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [showMenu, setShowMenu] = useState(true);

  const handleProductChange = (e, value) => {
    e.stopPropagation();

    setProduct(value);
    setDropdownVisible(false);

    dispatch(fetchAccounts({ page: 0, limit: 20, filters: { ...initFilters, product: value } }))

    history.push(`/${value}/accounts`);

  };

  useEffect(() => {
    const handleClick = event => {
      setDropdownVisible(false);
    }

    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  useEffect(() => {
    var activeItem = history.location.pathname.toString().replace("/", "");
    setActiveItem(activeItem)
  }, [])

  useEffect(() => {

    if (location.pathname.includes('/cleverstory')) {
      setProduct('cleverstory');
    } else {
      setProduct('paperflite');
    }

    if (location.pathname.includes("dashboard")) {
      setActiveItem("dashboard");
    } else if (location.pathname.includes("metrics")) {
      setActiveItem("metrics");
    } else {
      setActiveItem("accounts");
    }

  }, [location.pathname]);

  useEffect(() => {

    if (AuthService.isAuthenticated()) {
      dispatch(fetchUserProfile());
    }

  }, [AuthService.isAuthenticated()]);

  useEffect(() => {
    if (pathname.indexOf("management") > -1 || pathname.indexOf("reports") > -1 || pathname.indexOf("iadb_interactive_content") > -1) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }

  }, [pathname]);

  const onLogout = () => {

    dispatch({ type: LOGOUT_COGNITO_USER });

    history.push({
      pathname: "/login"
    });

  };

  const onSetActiveItem = (item) => {
    setActiveItem(item);

    history.push({
      pathname: `/${product}/${item}`
    });

  };

  const getNavItemStyle = (item) => {
    if (activeItem === item) return styles.navItemActive;
    return styles.navItem;
  };

  const getProductLogo = () => {
    if (product === "cleverstory") {
      return CS_Logo;
    } else {
      return PF_Logo;
    }
  }

  const getProductAltText = () => {
    if (product === "cleverstory") {
      return "Cleverstory";
    } else {
      return "Paperflite";
    }
  }

  const handleProductClick = (e) => {
    e.stopPropagation();

    setDropdownVisible(true);
  };

  return (
    <>
      <Menu
        pointing
        secondary
        fixed="top"
        vertical={false}
        className={cx(styles.navbar)}
      >
        <Menu.Item
          className={cx(styles.logo)}
          onClick={() => onSetActiveItem("")}
        >
          <div onClick={(e) => handleProductClick(e)} className={styles.imageContainer}>
            <Image
              src={getProductLogo()}
              className={styles.image}
              alt={getProductAltText()}
            />

            <div className={styles.dropdownIcon}>
              <i aria-hidden="true" className={cx(styles.logo, 'dropdown icon')}></i>
            </div>

            {isDropdownVisible && (
              <div className={cx(styles.backGround)}>
                <p onClick={(e) => handleProductChange(e, 'paperflite')}>Paperflite</p>
                <p onClick={(e) => handleProductChange(e, 'cleverstory')}>Cleverstory</p>
              </div>
            )}
          </div>

        </Menu.Item>

        {showMenu &&
          <>
            <Menu.Item
              name="Accounts"
              active={activeItem === "accounts"}
              className={cx(styles.center, getNavItemStyle("accounts"))}
              onClick={() => onSetActiveItem("accounts")}
            />

            <Menu.Item
              name="Dashboard"
              active={activeItem === "dashboard"}
              className={getNavItemStyle("dashboard")}
              onClick={() => onSetActiveItem("dashboard")}
            />

            <Menu.Item
              name="Metrics"
              active={activeItem === "metrics"}
              className={getNavItemStyle("metrics")}
              onClick={() => onSetActiveItem("metrics")}
            />
          </>}


        <Menu.Menu position="right">
          {me && (
            <Menu.Item className={cx(styles.user)}>
              <Image
                size="mini"
                className={cx(styles.image)}
                src={
                  "https://react.semantic-ui.com/images/avatar/large/steve.jpg"
                }
              />
              <span className={cx(styles.name)}> {me.name}</span>
            </Menu.Item>
          )}

          <Menu.Item className={cx(styles.logout)}>
            <Icon
              name="sign-out"
              className={cx(styles.icon)}
              onClick={onLogout}
            />
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    </>
  );
}
